var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlumbing = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09566 9.96325H14.6765V11.6195H16.2126V8.42715H12.7181V4.53609H15.8797V3H8.12794V4.53609H11.1821V8.42715H7.55957V11.4327H9.09566V9.96325Z",
    fill: "#327372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8883 27.0639V23.6335C27.8854 20.7066 26.7216 17.9001 24.6522 15.8301C22.5828 13.7602 19.7763 12.5956 16.8497 12.5923H4.53609V10.936H3V21.9852H4.53609V20.4286H6.5227H6.52252C7.81075 22.115 9.80983 23.1064 11.9319 23.1114C14.0539 23.1164 16.0576 22.1345 17.3541 20.4543C18.0232 20.5455 18.6362 20.8766 19.0794 21.3863C19.5226 21.8958 19.7655 22.549 19.763 23.2241V27.0641H19.0257V28.6002H28.6001V27.0641L27.8883 27.0639ZM16.9799 18.8925H16.5678L16.3399 19.233C15.3565 20.6966 13.709 21.5744 11.9456 21.5744C10.1824 21.5744 8.53495 20.6966 7.55136 19.233L7.3235 18.8925H4.53584V14.1286H16.8494C19.3691 14.132 21.7848 15.1345 23.5662 16.9164C25.3477 18.6984 26.3497 21.1141 26.3523 23.6337V27.064H21.299V23.224C21.301 22.0769 20.8471 20.976 20.0371 20.1635C19.2271 19.3512 18.1275 18.8939 16.9803 18.8926L16.9799 18.8925Z",
    fill: "#327372"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlumbing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plumbing.9862ac41.svg";
export { ForwardRef as ReactComponent };